import * as Sentry from "@sentry/nextjs";

/**
 * Check if a string is a valid JSON and report to sentry if it doesn't
 * @param str string to check
 * @returns true if the string is a valid JSON, false otherwise
 */
export function isValidJson(str) {
  if (typeof str !== 'string') {
    return false;
  }
  str = str.trim();
  if (str.startsWith('{') && str.endsWith('}') || str.startsWith('[') && str.endsWith(']')) {
    try {
      const parsed = JSON.parse(str);
      return typeof parsed === 'object' && parsed !== null;
    } catch (e) {
      console.error('Error parsing JSON:', e, 'string:', str);
      Sentry.captureException(e);
      return false;
    }
  }
  return false;
}